import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

const FormText = ({ id, className, children, ...props }) => {
	return (
		// eslint-disable-next-line react/jsx-props-no-spreading
		<div className={classNames('form-text', className)} id={id} {...props}>
			{children}
		</div>
	);
};
FormText.propTypes = {
	/**
	 * Form text should be explicitly associated with the form control it relates to using the *ariaDescribedby(aria-describedby)* attribute.
	 */
	id: PropTypes.string,
	/**
	 * Has a default *form-text* class. Your entries will also be added to this.
	 */
	className: PropTypes.string,
	/**
	 * Here you can use string, component or html element
	 */
	children: PropTypes.node.isRequired,
};
FormText.defaultProps = {
	id: null,
	className: null,
};

export default FormText;
